<div [formGroup]="form">
  <mat-checkbox [checked]="checked" formControlName="checkbox" name="{{ name }}" [disabled]="isDisabled"
    [aria-label]="ariaLabel" class="{{ cssClass }}"
    [ngClass]="{ 'is-invalid': control && control.errors && control.dirty }" [attr.data-cy-input]="automationTag"
    (change)="changed($event)">
    {{ label }}
    <ng-content></ng-content>
  </mat-checkbox>
  <hospitable-validation-message [control]="control" [validators]="validators"> </hospitable-validation-message>
</div>